export default "__VITE_ASSET__CcxKRb6t__"